<sdps-modal-beta (close)="onModalClose($event)" [attr.sdps-title]="title" id="save-as-template-modal">
    <div slot="modal-body">
      <div class="sdps-text-body" class="save-template-modal-messaging">{{textBody}}</div>
      <mm-text-input-control [parentForm]="saveAsTemplateModalForm" [inputControlModel]="nicknameModel" 
        id="save-template-nickname" [errorMessage]="nicknameError || ''" class="save-template-nickname"></mm-text-input-control>
    </div>
    <div slot="modal-footer">
      <button (click)="onCancelClick()" type="button"
        class="sdps-button sdps-button--small sdps-button--secondary">Cancel</button>
      <button (click)="onSaveTemplateClick()" type="button"
        class="sdps-button sdps-button--primary sdps-button--small" id="save_template_modal_save_button">Save</button>
    </div>
  </sdps-modal-beta>
  